module.exports = __webpack_public_path__ + "img/ac.ac75ec39a.svg";